import Appointment from './views/appointmentContainer'

export const appointmentRouter = [{
  path: '/add-appointment/:user/:sinisterId/:warrantyId',
  name: 'add-appointment',
  component: Appointment
}]
